import { ConfigurationType } from './types/ConfigurationType';

const config: ConfigurationType = {
    scope: process.env.REACT_APP_MSAL_CLIENT_SCOPE || "{MSAL_SCOPE}",
    clientAuthority: process.env.REACT_APP_MSAL_AUTHORITY || "{MSAL_AUTHORITY}",
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || "{MSAL_CLIENT_ID}",
    apiBaseUrl: process.env.REACT_APP_API_BASEURL || "{API_BASE_URL}",
}

export { config };